import CommonTypes from './CommonTypes';

export const setFilterToggle = (payload) => ({
  payload,
  type: CommonTypes.SET_FILTER_TOGGLE,
});

export const setShipmentModal = (payload) => ({
  payload,
  type: CommonTypes.SET_SHIPMENT_SIDE_BAR_TOGGLE,
});

export const setAppLoader = (payload) => ({
  payload,
  type: CommonTypes.SET_APP_LOADER,
});

export const setFullScreenInstance = (payload) => ({
  payload,
  type: CommonTypes.SET_FULL_SCREEN_INSTANCE,
});

export const setDocumentTypesList = (payload) => ({
  payload,
  type: CommonTypes.SET_DOCUMENT_TYPES_LIST,
});

export const setWarningModal = (payload) => ({
  payload,
  type: CommonTypes.SET_WARNING_MODAL,
});

export const getPostalSearchProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_POSTAL_SEARCH_PROGRESS,
  };
};
export const getPostalSearchSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_POSTAL_SEARCH_SUCCESS,
  };
};
export const getPostalSearchError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_POSTAL_SEARCH_ERROR,
  };
};
export const getPostalSearchReset = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_POSTAL_SEARCH_RESET,
  };
};

export const getPortSearchProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_PORT_SEARCH_PROGRESS,
  };
};
export const getPortSearchSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_PORT_SEARCH_SUCCESS,
  };
};
export const getPortSearchError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_PORT_SEARCH_ERROR,
  };
};

export const setPageBlocker = (payload) => ({
  payload,
  type: CommonTypes.SET_PAGE_BLOCKER,
});

export const getCarrierSearchProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_SEARCH_PROGRESS,
  };
};
export const getCarrierSearchSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_SEARCH_SUCCESS,
  };
};
export const getCarrierSearchError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_SEARCH_ERROR,
  };
};
export const getCarrierSearchReset = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_SEARCH_RESET,
  };
};

export const setLossAndDamageClaimsStatusList = (payload) => ({
  payload,
  type: CommonTypes.SET_LOSS_AND_DAMAGE_STATUS_LIST,
});

export const setLADClaimsRegionList = (payload) => ({
  payload,
  type: CommonTypes.SET_LAD_CLAIMS_REGION_LIST,
});

export const setLADClaimsProcessorList = (payload) => ({
  payload,
  type: CommonTypes.SET_LAD_CLAIM_PROCESSOR_LIST,
});

export const setLDClaimCommodityCodeList = (payload) => ({
  payload,
  type: CommonTypes.SET_LD_CLAIMS_COMMODITY_CODE_LIST,
});

export const setLDClaimLidLabelList = (payload) => ({
  payload,
  type: CommonTypes.SET_LD_CLAIMS_LID_LABEL_LIST,
});

export const getCarrierDetailsInProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_DETAILS_PROGRESS,
  };
};
export const getCarrierDetailsInSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_DETAILS_SUCCESS,
  };
};
export const getCarrierDetailsInError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CARRIER_DETAILS_ERROR,
  };
};

export const setShipmentStopTypes = (payload) => ({
  payload,
  type: CommonTypes.SET_SHIPMENT_STOP_TYPES_LIST,
});

export const setShipmentAppointmentTypes = (payload) => ({
  payload,
  type: CommonTypes.SET_SHIPMENT_APPOINTMENT_TYPES_LIST,
});

export const setShipmentProductQtyUomList = (payload) => ({
  payload,
  type: CommonTypes.SET_SHIPMENT_PRODUCT_QTY_UOM_LIST,
});

export const setShipmentProductDimUomList = (payload) => ({
  payload,
  type: CommonTypes.SET_SHIPMENT_PRODUCT_DIM_UOM_LIST,
});

export const setPalletPackageTypeList = (payload) => ({
  payload,
  type: CommonTypes.SET_PALLET_PACKAGE_TYPE_LIST,
});

export const getNewSpotQuoteNoInProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_IN_PROGRESS,
  };
};

export const getNewSpotQuoteNoSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_SUCCESS,
  };
};

export const getNewSpotQuoteNoError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_ERROR,
  };
};

export const createSpotQuoteInProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.CREATE_SPOT_QUOTE_PROGRESS,
  };
};

export const createSpotQuoteInSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.CREATE_SPOT_QUOTE_SUCCESS,
  };
};

export const createSpotQuoteReset = () => {
  return {
    type: CommonTypes.CREATE_SPOT_QUOTE_RESET,
  };
};

export const createSpotQuoteInError = (payload) => {
  return {
    payload,
    type: CommonTypes.CREATE_SPOT_QUOTE_ERROR,
  };
};

export const setCurrentQuoteRoutingGuidesParams = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS,
  };
};

export const resetCurrentQuoteRoutingGuidesParams = (payload) => {
  return {
    payload,
    type: CommonTypes.RESET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS,
  };
};

export const setCurrentQuoteCarriers = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_CURRENT_QUOTE_CARRIERS,
  };
};

export const addToCurrentQuoteCarriers = (payload) => {
  return {
    payload,
    type: CommonTypes.ADD_TO_CURRENT_QUOTE_CARRIERS,
  };
};

export const removeCurrentQuoteCarrier = (payload) => {
  return {
    payload,
    type: CommonTypes.REMOVE_CURRENT_QUOTE_CARRIER,
  };
};

export const resetCurrentQuoteCarrier = (payload) => {
  return {
    payload,
    type: CommonTypes.RESET_CURRENT_QUOTE_CARRIER,
  };
};

export const getCurrentQuoteCollaboratorsList = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_CURRENT_QUOTE_COLLABORATORS_LIST,
  };
};

export const setCurrentQuoteCollaborators = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_CURRENT_QUOTE_COLLABORATORS,
  };
};

export const addToCurrentQuoteCollaborators = (payload) => {
  return {
    payload,
    type: CommonTypes.ADD_TO_CURRENT_QUOTE_COLLABORATORS,
  };
};

export const removeCurrentQuoteCollaborators = (payload) => {
  return {
    payload,
    type: CommonTypes.REMOVE_CURRENT_QUOTE_COLLABORATORS,
  };
};

export const resetCurrentQuoteCollaborators = (payload) => {
  return {
    payload,
    type: CommonTypes.RESET_CURRENT_QUOTE_COLLABORATORS,
  };
};

export const getSpotQuoteCreatorSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_SPOT_QUOTE_CREATOR_SUCCESS,
  };
};

export const getSpotQuoteCreatorError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_SPOT_QUOTE_CREATOR_ERROR,
  };
};

export const setQuoteModalBlocker = (payload) => ({
  payload,
  type: CommonTypes.SET_QUOTE_MODAL_BLOCKER,
});

export const setQuoteSpotBidSaveError = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_QUOTE_SPOT_BID_SAVE_ERROR,
  };
};

export const setQuoteBidExpirationDate = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_QUOTE_BID_EXPIRATION_DATE,
  };
};

export const resetQuoteBidExpirationDate = (payload) => {
  return {
    payload,
    type: CommonTypes.RESET_QUOTE_BID_EXPIRATION_DATE,
  };
};

export const setQuoteActiveAccordions = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_QUOTE_ACTIVE_ACCORDIONS,
  };
};

export const getSpotQuoteTransportationInProgress = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_PROGRESS,
  };
};

export const getSpotQuoteTransportationInSuccess = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_SUCCESS,
  };
};

export const getSpotQuoteTransportationInError = (payload) => {
  return {
    payload,
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_ERROR,
  };
};

export const setCopyQuoteKey = (payload) => {
  return {
    payload,
    type: CommonTypes.SET_COPY_QUOTE_KEY,
  };
};

export const resetCopyQuoteKey = (payload) => {
  return {
    payload,
    type: CommonTypes.RESET_COPY_QUOTE_KEY,
  };
};
